"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "Please start by writing a very short description of the problem that’s making it harder to return to work.",
  type: "textarea",
  meta: {
    answerLabel: "My problem is...",
    summaryTitle: "Problem which is making it harder to return to work",
    placeholderText: "Example: I'm so hard on myself."
  },
  batteryId: "PROBLEM_DEFINITION"
}, {
  prompt: "Why is it a problem?",
  type: "textarea",
  meta: {
    answerLabel: "This is a problem because...",
    summaryTitle: "Why is it a problem?",
    placeholderText: "Example: It's not healthy."
  },
  batteryId: "PROBLEM_DEFINITION"
}, {
  prompt: "When, with whom and where does it happen?",
  type: "textarea",
  meta: {
    answerLabel: "This is a problem because...",
    summaryTitle: "When, with whom and where does it happen?",
    placeholderText: "Example: It's not healthy."
  },
  batteryId: "PROBLEM_DEFINITION"
}, {
  prompt: "What have you tried to do about this problem?",
  type: "textarea",
  meta: {
    answerLabel: "This is a problem because...",
    summaryTitle: "What have you tried to do about this problem?",
    placeholderText: "Example: It's not healthy."
  },
  batteryId: "PROBLEM_DEFINITION"
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      return {
        question: question,
        answer: answers[question.batteryId][index]
      };
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;